import { createCRUDHook } from './createCRUDHook';
import { ProductionProcessDto } from 'utils/models';
import { TLKP_PRODUCTION_PROCESS } from './apiEndPoints';

// Create the CRUD hook - that's it!
const { Context, useManager, useConsumer } =
  createCRUDHook<ProductionProcessDto>({
    entityName: 'ProductionProcess',
    endpoint: TLKP_PRODUCTION_PROCESS,
  });

export const ProductionProcessContext = Context;
export const useProductionProcessManager = useManager;
export const useProductionProcess = useConsumer;
